// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideWrench as RawLucideWrench } from "lucide-react";
export const LucideWrench = /* @__PURE__ */ createIcon(RawLucideWrench, "LucideWrench", 2);
